import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment'
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ShipmentBadge from "../../../../components/ShipmentBadge.vue";

export default {
  name: 'ShipmentScanTallyNew',
  components: {
    VueElementLoading,
    Paginate,
    swal,
    ShipmentBadge
  },
  mixins: [PageTracker],
  data: function () {
    return {
      badge: {
        colorCode: "",
        icon: "",
        shipment: "",
      },
      scanBadgeFlag: false,
      hubname: '',
      dateobj: {
        toDate: ''
      },
      hubServiceCenterList: [],
      shipmentDetailsFlag: false,
      scanShipmentBatchFlag: false,
      showBatchesFlag: false,
      comments: '',
      shippingId: '',
      localusermailid: '',
      localuserid: '',
      rolename: '',
      max: 500,
      shipmentStatusType: '',
      errormsg: [],
      Ismannual: 'true',
      checkValue: 0,
      BatchNo: '',
      OutSourcingMasterId: '',
      getSummaryObj: [],
      getShipmentScanObj: [],
      Loading: false,
      file: '',
      scanFlag: true,
      validated: true,
      batchStatus: '',
      styleObject: {
        'margin-bottom': '15px',
        'background-color': '#fff'
      },
      OverageShipmentError: '',
      IsImageUploadRequired: false,
      changeStatus: '1',
      ScanTally: '1',
      Audit: '0',
      Include: '',
      exclude: '',
      commentsObjList: [],
      excludeList: [{ "eId": "OFD", "excludeName": "OFD Shipments" }],
      IncludeList: [{ "IncludeId": "BagIn", "IncludeName": "BagIn Shipments" }],
      imageListObject: [],
      getShipmentList: [],
      ShipmentDetailsLoading: false,
      commentsForManualEntry: [{ text: 'Barcode Damage', value: '1' }, { text: 'Unable to scan Barcode', value: '2' }],
      toggleFlag: false,
      SetReadonlyMode: true,
      InscanLoading: false,
      dismissSecs: 15,
      dismissCountDown: 0,
      dismissCountDownSuccess: 0,
      keyFiredCount: { 'value': 0 },
      uploadLoading: false,
      generateBatchLoader: false,
      shipmentDetailsModel: false,
      isCloseButtonUpload: false,
      invalidFile: {},
      roleWiseAudit: false,
      roleWiseScantally: false,
      getModelBatchNo: '',
      scanTallyBatchId: '',
      syncDataflag: false,
      syncDataLimit: 0,
      dismissCountDownSuccessforSync: 0,
      shipmenttallysummary: [],
      parseData: [],
      ofdclosureflag : false,
      downloadShipmentDetailsLoading : false,
      partialCloseFlag : false,
      partialCloseModal : false,
      isDownloadflag: false,
      userDataKey : '',
      userRolesFE: [],
      batchfullclosureReason: [],
      isManualShipmentScanAllowed: false,
    }
  },
  created: function () {
    this.getHubList();
    this.changeDateFormat();
    this.getAuditCommentList();
    this.getSyncDataLimit()
  },
  filters: {
    moment: function (date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    setbucketname: function (bname) {
      switch(bname) {
        case 'TotalShipmentCount':
          return 'Total ScanTally Eligible'

        case 'TotalScanShipments':
          return 'Total Scanned'

        case 'PendingInScan':
          return 'Pending Scantally'

        case 'totalOverageShipments':
          return 'Overage'

        case 'totalShortage':
          return 'Shortage'

        case 'totalRADShipments':
          return 'RAD Shipments'

        case 'TotalOFDShipments':
          return 'OFD/Status Pending'

        case 'totalLostShipments':
          return 'Lost Marked'

        case 'totalDamageShipments':
          return 'Damaged'

        case 'totalSnatchedShipments':
          return 'Snatched'

        case 'totalDeliveredShipments':
          return 'Delivered'

        case 'totalNDRShipments':
          return 'NDR'

        case 'totalInternalAccountShipments':
          return 'Internal Account Shipments'

        case 'totalDisputeShipments':
          return 'Dispute'

        default:
          return "NA";
      }
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    //  console.log('userdetail',userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.userRolesFE = userdetail.userroleFE;
    // console.log('this.rolename', this.rolename);

    this.hubname = userdetail.hubdetails[0];
    this.OutSourcingMasterId = userdetail.outsourcingid;
    this.roleWiseScantally = (this.rolename.toLowerCase().trim() != 'auditscantally'  || !this.userRolesFE.includes("auditscantally")) ? true : false;
    this.roleWiseAudit = ((this.rolename.toLowerCase().trim() == 'admin' || this.userRolesFE.includes("admin")) || (this.rolename.toLowerCase().trim() == 'auditscantally' || this.userRolesFE.includes("auditscantally"))) ? true : false;
    this.changeStatus = this.roleWiseAudit == true ? '1' : '0'
    const vm = this;
    this.getScanTallyObject(this.roleWiseScantally, this.roleWiseAudit, this.changeStatus);
    var keyupFiredCount = 0;
    $("#shippingId").keyup(this.DelayExecution(function (event) {
      let keycode = (event.keyCode ? event.keyCode : event.which);
      vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
      vm.oncallImediate(keycode);
      vm.setIsMannual();
    }));
    this.batchfullclosureReason = await this.getScantallyBatchClosureReasons();

  },
  methods: {
    oncallImediate(keycode) {
      if ($("#shippingId").val() == '') {
        this.keyFiredCount.value = 0;
        this.comments = '';
        return false;
      }
      if (this.keyFiredCount.value <= 1 && keycode == 13) {
        this.Ismannual = false;
        this.checkValue = 0;
        this.keyFiredCount.value = 0;
      } else {
        this.Ismannual = true;
        this.checkValue = 1;
        if(!this.isManualShipmentScanAllowed){
          this.$validator.errors.add({
            field: "manualEntryAllowed",
            msg: "Manual entry is not allowed — please scan the Shipping ID.",
            scope: "form-1"
          });
        }
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
          f.apply(context, args);
        },
          delay || 200);
      };
    },
    setIsMannual() {
      if (this.shippingId == '') {
        this.Ismannual = false;
        this.checkValue = 0;
        this.errors.clear();
      }
    },
    IsmannulCheck(typests) {
      if (typests == 'B') {
        this.Ismannual = false;
        this.checkValue = 0;
        //this.validateForm('form-1');
      } else {
        this.Ismannual = true;
        this.checkValue = 1;
      }
    },
    validateForm(scope) {

      if (!this.isManualShipmentScanAllowed && this.Ismannual) {
          return;
      }
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.InscanLoading = true;
          this.scanBadgeFlag = false;
          this.badge = {
            colorCode: "",
            icon: "",
            shipment: ""
          }
          this.getShipmentScanObj = [];
          if (this.batchStatus.toLowerCase().trim() == 'closed') {
            this.$alertify.error("Batch already closed.");
          } else if (this.shippingId && (this.shippingId.startsWith('A') || this.shippingId.startsWith('S') || this.shippingId.startsWith('M'))) {
            this.$alertify.error("Invalid cargo shipments.!");
            this.InscanLoading = false;
            this.clearScanForm();
            $("#shippingId").focus();
          } else {
            let ScanTallyModule = {
              "ShippingID": (this.shippingId).replace(/\s/g, ''),
              "LastModifiedBy": this.localusermailid
            }

            axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/shipment/get', ScanTallyModule)
              .then((response) => {

                let inscanPayload = {};

                let string_substr = this.shippingId.trim().substr(0, 3);
                let IsRECShipments;
                if (string_substr.toLowerCase().trim() == 'rec') {
                  IsRECShipments = true;
                } else {
                  IsRECShipments = false;
                }
                let responseFields = {};
                if (response.data.code === 200 && (response.data.data.ShipmentStatus.toLowerCase().trim() != 'pending' && response.data.data.Status.toLowerCase().trim() != 'pending')) {
                  let resultObj = response.data.data;
                  let calculateScantallyPriority = "";
                    if( resultObj.Scantally_Priority_Details ) {
                      this.scanBadgeFlag = true
                      this.badge = {
                        colorCode: resultObj.Scantally_Priority_Details.colorCode,
                        icon: resultObj.Scantally_Priority_Details.icon,
                        shipment: resultObj.Scantally_Priority_Details.shipment
                      }
                      calculateScantallyPriority = resultObj.Scantally_Priority_Details.CalculatedPriority ?  resultObj.Scantally_Priority_Details.CalculatedPriority : ''
                    }
                    console.log("this.badge =================>>>", this.badge);
                  if(resultObj.IsOFDShipment) {
                    console.log('OFD Shipments found exist in the system', resultObj);
                    this.$alertify.error("Shipment status is in OFD, Please mark either delivered or ndr.!");
                    this.InscanLoading = false;
                    return false;
                  }else if (['shortage','rtoshortage','delivered','whhandover'].includes(resultObj.Status.toLowerCase())){
                    this.$alertify.error(`Shipment status is in ${resultObj.Status}, You cannot Scan this shipment.!`);
                    this.InscanLoading = false;
                    return false;
                  }else if (resultObj.Status && resultObj.ShipmentStatus && ['std','lost'].includes(resultObj.Status.toLowerCase()) && ['std','lost'].includes(resultObj.ShipmentStatus.toLowerCase())) {
                    this.$alertify.error(`Shipment status is in ${resultObj.Status}, You cannot Scan this shipment.!`);
                    this.InscanLoading = false;
                    return false;
                  }
                  // else if(resultObj.islostnotify && this.Ismannual) {
                  //   this.$alertify.error(`Shipment marked no info pending / lost notified, You cannot Manually Scan this shipment.!`);
                  //   this.InscanLoading = false;
                  //   return false;
                  // }
                  responseFields.TotalAttemptCount = resultObj.TotalAttemptCount;
                  let reattemptFormatDate = resultObj.ReAttemptDate != null ? moment(resultObj.ReAttemptDate).format('YYYY-MM-DD HH:mm:ss') : '';
                  responseFields.ReAttemptDate = reattemptFormatDate;
                  responseFields.NotificationStatus = resultObj.NotificationStatus;
                  responseFields.PDD = resultObj.pdd;
                  responseFields.LastComments = resultObj.LastComments

                  this.OverageShipmentError = '';
                  //background colors validations
                  if (resultObj.ShipmentStatus.toLowerCase().trim() == 'inscan' && resultObj.Status.toLowerCase().trim() != 'rto') {
                    this.styleObject = {
                      "background-color": "Silver"
                    }
                  } else if (resultObj.ShipmentStatus.toLowerCase().trim() == 'lost') {
                    this.styleObject = {
                      "background-color": "greenyellow"
                    }
                  } else if (resultObj.Status.toLowerCase().trim() == 'rto') {
                    this.styleObject = {
                      "background-color": "red"
                    }
                  } else if (resultObj.ShipmentStatus.toLowerCase().trim() == 'std') {
                    this.styleObject = {
                      "background-color": "aquamarine"
                    }
                  } else if (resultObj.ShipmentStatus.toLowerCase().trim() == 'handover') {
                    this.styleObject = {
                      "background-color": "skyblue"
                    }
                  } else if (resultObj.ShipmentStatus.toLowerCase().trim() == 'whhandover') {
                    this.styleObject = {
                      "background-color": "lightsalmon"
                    }
                  } else if (resultObj.ShipmentStatus.toLowerCase().trim() == 'overage') {
                    this.styleObject = {
                      "background-color": "forestgreen"
                    }
                  } else if (resultObj.ShipmentStatus.toLowerCase().trim() == 'nts') {
                    this.styleObject = {
                      "background-color": "deepskyblue"
                    }
                  } else {
                    this.styleObject = {
                      "background-color": "Silver"
                    }
                  }
                  if (resultObj.NotificationStatus != null && resultObj.NotificationStatus.toLowerCase().trim() == 'reattempt') {
                    if (resultObj.ReAttemptDate != null) {
                      let currentDate = new Date();
                      let formatDate = moment(currentDate).format('YYYY-MM-DD');
                      let ReAttemptDate = moment(resultObj.ReAttemptDate).format('YYYY-MM-DD');
                      let checkSameDay = moment(formatDate).isSame(ReAttemptDate);
                      if (checkSameDay) {
                        this.styleObject = {
                          "background-color": "LightGreen"
                        }
                      } else {
                        this.styleObject = {
                          "background-color": "YellowGreen"
                        }
                      }
                    }
                  } else if (resultObj.NotificationStatus != null && resultObj.NotificationStatus.toLowerCase().trim() == 'escalation') {
                    this.styleObject = {
                      "background-color": "DarkOrange"
                    }
                  } else if (resultObj.NotificationType != null && resultObj.NotificationType.toLowerCase().trim() == 'rto') {
                    this.styleObject = {
                      "background-color": "LightCoral"
                    }
                  }else if(resultObj.Is_forward_rvp_esacalation == true && (resultObj.shipmenttype.toLowerCase().trim() == "delivery" || resultObj.shipmenttype.toLowerCase().trim() == "rvp" )){
                    this.styleObject = {
                      "background-color": "DarkOrange"
                    }
                  }else if(resultObj.Is_dto_rto_esacalation == true && (resultObj.shipmenttype.toLowerCase().trim() == "dto" || resultObj.shipmenttype.toLowerCase().trim() == "rto" )){
                    this.styleObject = {
                      "background-color": "DarkOrange"
                    }
                  }

                  let OutSourcingMasterId = null;
                  let IsInscan = true;
                  let IsOverage = '';
                  let IsNTSOverage = '';

                  if (resultObj.CurrentHubID != this.hubname ||
                    resultObj.ShipmentStatus.toLowerCase().trim() == "lost" ||
                    resultObj.ShipmentStatus.toLowerCase().trim() == "overage" ||
                    resultObj.IsOFDShipment == true) {
                    // (resultObj.ShipmentStatus.toLowerCase().trim() == "delivered" && resultObj.IsUpdatedLater == true ) ||
                    //  resultObj.ShipmentStatus.toLowerCase().trim() == "whhandover") {
                    IsOverage = true;
                  } else {
                    IsOverage = false;
                  }
                  if ((['pickupdone', 'pickdone'].includes(resultObj.ShipmentStatus.toLowerCase()) && resultObj.Status.toLowerCase().trim() == 'pending') || (resultObj.ShipmentStatus.toLowerCase().trim() == 'pending' && resultObj.Status.toLowerCase().trim() == 'pending')) {
                    IsNTSOverage = true
                  } else {
                    IsNTSOverage = false
                  }
                  inscanPayload = {

                    OutScourcingMasterId: OutSourcingMasterId,
                    HubID: this.hubname,
                    ShippingID: resultObj.ShippingId,
                    ServiceType: resultObj.ServiceType,
                    BatchID: this.BatchNo,
                    Status: resultObj.Status,
                    ShipmentStatus: resultObj.ShipmentStatus,
                    NotificationType: resultObj.NotificationType,
                    DeliveryStatus: 'null',
                    CurrentHubId: resultObj.CurrentHubID,
                    FinalDestinationID: resultObj.FinalDestinationID,
                    IsReversePick: resultObj.IsReversePick,
                    IsSupplierPick: resultObj.IsSupplierPick,
                    IsInscan: IsInscan,
                    IsOverage: IsOverage,
                    LastModifiedBy: this.localusermailid,
                    SMCreatedDate: resultObj.LastModifiedDate,
                    Comments: this.comments,
                    OctroiMRP: resultObj.DeclaredValue,
                    NetPayment: resultObj.NetPayment,
                    ShippingDate: resultObj.CreatedDate,
                    OrderType: resultObj.OrderType,
                    IsNTSOverage: IsNTSOverage,
                    IsAPI: resultObj.IsAPI,
                    UpdateFrom: resultObj.UpdateFrom,
                    IsOFD: resultObj.IsOFDShipment,
                    IsSeized: resultObj.IsSeized,
                    IsUpdatedLater: resultObj.IsUpdatedLater,
                    IsRECShipments: IsRECShipments,
                    NotificationStatus: resultObj.NotificationStatus,
                    shipmenttype: resultObj.shipmenttype,
                    islostnotifyval: resultObj.islostnotify,
                    calculateScantallyPriority: calculateScantallyPriority,
                  }

                } else {
                  let message = response.data.message ? response.data.message : 'Something went wrong!!'
                  this.$alertify.error(`Shipment cannot scanned, ${message}`);
                  this.InscanLoading = false;
                  return false;
                  this.styleObject = {
                    "background-color": "Blueviolet",
                    "margin-bottom": '15px'
                  }

                  responseFields.ReAttemptDate = '';
                  responseFields.NotificationStatus = '';
                  responseFields.PDD = '';

                  inscanPayload = {
                    BatchID: this.BatchNo,
                    IsInscan: true,
                    IsOverage: false,
                    IsNTSOverage: true,
                    IsRECShipments: IsRECShipments,
                    HubID: this.hubname,
                    ShippingID: this.shippingId,
                    ServiceType: "",
                    Status: "NoDataFound",
                    ShipmentStatus: "NoDataFound",
                    NotificationType: null,
                    DeliveryStatus: null,
                    CurrentHubId: null,
                    FinalDestinationID: null,
                    IsReversePick: false,
                    IsSupplierPick: false,
                    Comments: this.comments,
                    LastModifiedBy: this.localusermailid
                  }
                }
                if (this.batchStatus.toLowerCase().trim() == 'partialclose') {
                  inscanPayload.isPartialClose = true;
                } else {
                  inscanPayload.isPartialClose = false;
                }
                //console.log('inscanPayload',inscanPayload);
                //isPartialClose
                //iscan API Call start
                axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/inscan', inscanPayload)
                  .then((response) => {
                    if (response.data.code === 200) {
                      console.log("response.data.data ================>>", response.data.data);
                      this.getShipmentScanObj = response.data.data;
                      // this.getShipmentScanObj.ReAttemptDate = responseFields.ReAttemptDate != null ? responseFields.ReAttemptDate : "";
                      // // this.getShipmentScanObj.NotificationStatus = responseFields.NotificationStatus;
                      // this.getShipmentScanObj.PDD = responseFields.PDD;
                      // this.getShipmentScanObj.TotalAttemptCount = responseFields.TotalAttemptCount;
                      this.$alertify.success("Successfully done");
                      if (this.file != '' && this.file != undefined) {
                        this.uploadFile(event)
                      }
                    } else if (response.data.code === 202) {
                      this.getShipmentScanObj = response.data && response.data.data ? response.data.data : "";

                      let alertMsg = 'Unable to scan shipment in the scantally batch.';
                      if (
                        response &&
                        response.data &&
                        response.data.data &&
                        response.data.data.ScanMessage
                      ) {
                        alertMsg = response.data.data.ScanMessage;
                      } else if (
                        response &&
                        response.data &&
                        response.data.message &&
                        response.data.message.details &&
                        response.data.message.details[0] &&
                        response.data.message.details[0].message
                      ) {
                        alertMsg = response.data.message.details[0].message;
                      }


                      this.$alertify.error(alertMsg);
                    } else {
                      this.getShipmentScanObj = response.data && response.data.data ? response.data.data : "";
                      this.$alertify.error("Error");
                    }

                    this.getShipmentScanObj.ReAttemptDate = responseFields.ReAttemptDate != null ? responseFields.ReAttemptDate : "";
                    this.getShipmentScanObj.PDD = responseFields.PDD;
                    this.getShipmentScanObj.TotalAttemptCount = responseFields.TotalAttemptCount;
                    this.getShipmentScanObj.LastComments = responseFields.LastComments;

                    this.clearScanForm();
                    $("#shippingId").focus();
                    const el = this.$el.querySelector("#InscanResponse");
                    if (el) {
                      el.scrollIntoView();
                    }
                    this.InscanLoading = false;
                  })
                  .catch((httpException) => {
                    this.InscanLoading = false;
                    console.error('exception is:::::::::', httpException)
                  })
                //iscan API Call end
                this.scanFlag = true;
              })
              .catch((httpException) => {
                this.$alertify.error("Unable to scan shipment in scantally batch");
                this.InscanLoading = false;
                console.error('exception is:::::::::', httpException)
              })
          }
        }
      }).catch(() => {
        this.InscanLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    getHubList() {
      axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.hubServiceCenterList = response.data.data;
          }
          else {
            this.hubServiceCenterList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("hub data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getAuditCommentList() {

      axios.get(apiUrl.api_url + 'external/getreasons?reasonType=stAudit', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.commentsObjList = response.data.data;
          }
          else {
            this.commentsObjList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("hub data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    async getScantallyBatchClosureReasons() {
      try {
        const response = await axios.get(apiUrl.api_url + 'external/getreasons?reasonType=STbatchClosure');
        // console.log("response ----------->", response);
        if (response.data.code === 200) {
          return response.data.data;
        } else {
          return [];
        }
      } catch (error) {
        this.$alertify.error("Unable to fetch full batch closure reasons.");
        console.error('exception is:::::::::', error);
        return [];
      }
    },
    handleDragOver(event) {
      event.preventDefault();
    },
    generateBatch() {
      this.generateBatchLoader = true;
      this.errormsg = [];
      let scantAt = 'servicecenter';
      let OutSourcingMasterId = '';
      let BatchType = this.changeStatus == 1 ? 'ScanTally' : 'Audit';
      let generateBatchPayload = {
        "CurrentHubID": this.hubname,
        "OutSourcingMasterId": OutSourcingMasterId != '' ? OutSourcingMasterId : null,
        "LastModifiedBy": this.localusermailid,
        "ScanTallyAt": scantAt,
        "BatchType": BatchType,
        "StartTime": null,
        "CloseTime": null,
        "Source": "",
        "ExcludeCriteria": this.exclude,
        "IncludeCriteria": this.Include
      }
      //console.log('this.rolename',generateBatchPayload);
      axios.post(apiUrl.api_url_for_scantally + 'scantally/generateNewBatch', generateBatchPayload)
        .then((response) => {
          if (response.data.code === 200) {
            //this.scanShipmentBatchFlag = true;
            // this.PageTracker(TrackerInfo);
            this.BatchNo = response.data.BatchID;
            this.errormsg.push({
              "message": response.data.message,
              "code": response.data.code
            });
            this.changeDateFormat()
            // this.showBatch()
            this.getSummaryObj = '';
            this.getBatchDetails();
            this.dismissCountDownSuccess = this.dismissSecs

            const el = this.$el.querySelector("#shippingId")
            if (el) {
              el.scrollIntoView();
            }
            this.batchStatus = 'ProcessDone'
            this.BatchNo = response.data.BatchID
            // this.scanShipmentBatchFlag = true
            this.getShipmentScanObj = []
            this.scanFlag = false
            $("#shippingId").focus()
            this.getInscanImageList()
            this.clearScanForm()

          } else if (response.data.code == 203) {
            this.getBatchDetails()
            this.errormsg.push({
              "message": response.data.message,
              "code": response.data.code
            });
            this.scanShipmentBatchFlag = false;
            this.getSummaryObj = '';
            this.showBatchesFlag = true;
            this.dismissCountDown = this.dismissSecs
          } else {
            this.errormsg.push({
              "message": response.data.message,
              "code": response.data.code
            });
            this.scanShipmentBatchFlag = false;
            this.getSummaryObj = '';
            this.showBatchesFlag = true;
            this.dismissCountDown = this.dismissSecs
          }
          this.generateBatchLoader = false;
          this.changeDateFormat();

        })
        .catch((httpException) => {
          this.scanShipmentBatchFlag = false;
          this.generateBatchLoader = false;
          this.$alertify.error("Unable to generate batch");
          console.error('exception is:::::::::', httpException)
        })
      //console.log('generate batch triggred',generateBatchPayload);
    },
    getBatchDetails() {
      this.scanShipmentBatchFlag = false
      this.Loading = true;
      this.shipmentDetailsFlag = false;
      let scantAt = 'servicecenter';
      let OutSourcingMasterId = null;
      let BatchType = this.changeStatus == 1 ? 'ScanTally' : 'Audit';
      this.showBatchesFlag = true;
      let batchPayload = {
        "HubID": this.hubname,
        "FromDate": this.dateobj.toDate,
        "BatchId": '',
        "ScanTallyAt": scantAt,
        "BatchType": BatchType,
        "OutSourcingMasterId": OutSourcingMasterId
      }
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/new/getSummary', batchPayload)
        .then((response) => {
          //console.log('response',response);
          if (response.data.code === 200) {
            this.getSummaryObj = response.data.data;
            console.log("this.getSummaryObj---->", this.getSummaryObj)

            if (this.getSummaryObj.length > 0) {
              let scanTallyBatch = this.filterOpenStatus(this.getSummaryObj)
              let pendingInScanCount = this.getTotal(scanTallyBatch, 'PendingInScan')
              if (scanTallyBatch.length > 0 && (this.rolename.toLowerCase().trim() == 'admin' || this.userRolesFE.includes("admin"))) {
                this.syncDataflag = true
                this.scanTallyBatchId = scanTallyBatch[0].BatchID
                this.syncDataLimit = 0
              } else if (scanTallyBatch.length > 0 && (pendingInScanCount != 0 || this.syncDataLimit != 0) && (pendingInScanCount <= this.syncDataLimit)) {
                this.syncDataflag = true
                this.scanTallyBatchId = scanTallyBatch[0].BatchID
              } else {
                this.syncDataflag = false
              }
            }
            const el = this.$el.querySelector("#batchTable");
            if (el) {
              el.scrollIntoView();
            }
          } else if (response.data.code === 202) {
            this.getSummaryObj = [];
          } else {
            this.getSummaryObj = [];
          }
          this.Loading = false;
          // this.dismissCountDownSuccess = this.dismissSecs
        })
        .catch((httpException) => {
          this.Loading = false;
          this.scanShipmentBatchFlag = false;
          this.$alertify.error("Unable to get summary details");
          console.error('exception is:::::::::', httpException)
        })
      $("#shippingId").focus();
    },
    async CloseBatch(batchStatus, BatchId, openBatchData) {

      let checkOFDData = this.getTotal(openBatchData,'TotalOFDShipments')
      let checkPendingData = this.getTotal(openBatchData,'PendingInScan')
      console.log('batchStatus ------------>', batchStatus);

      //request object builds.
      let currentDateTime = new Date();
      let closeTime = currentDateTime.getHours() + '' + currentDateTime.getMinutes();
      let batchClosePayload = {
        "BatchID": BatchId,
        "CurrentHubID": this.hubname,
        "Status": batchStatus,
        "LastModifiedBy": this.localusermailid,
        "CloseTime": closeTime,
        "Source": "mannual"
      }

      if (checkOFDData && checkOFDData > 0 && this.ofdclosureflag == false) {
        //ofd restriction.
        this.$alertify.error("Cannot close the batch as OFD count is still " + `${checkOFDData}`);

      } else if(checkPendingData && checkPendingData > 0 && !this.partialCloseFlag && batchStatus.toLowerCase()=='closed') {

        this.$alertify.error("Cannot close the batch, Scantally for all pending shipments is not completed for this batch!");

      } else if(checkPendingData && checkPendingData > 0 && this.partialCloseFlag && batchStatus.toLowerCase()=='closed') {

        let reasons = []
        if( this.batchfullclosureReason.length ) {
          reasons = this.batchfullclosureReason.map((obj) => { return { value: obj.Reason, label: obj.Reason} });
        }

        // Build dropdown options dynamically
        const optionsHtml = reasons
          .map(r => `<option value="${r.value}">${r.label}</option>`)
          .join("");

        const { isConfirmed, value } = await swal.fire({
          title: '<h6 style="text-align:left">Important Alert!</h6>',
          html: `
            <p style="color: red; font-weight: bold; font-size:14px; text-align:left">
              Scantally for all pending shipments is not completed for this batch!
            </p>
            <p style="color: green; margin-top: 10px; font-size:14px; text-align:left">
              Do you want to close this batch?
            </p>

            <div style="display: flex; align-items: center; gap: 10px; text-align:left;font-size: 14px;">
              <label class="required-label" for="reasonDropdown" style="white-space: nowrap;">Select Reason: <span style="color: red;">*</span></label>
              <select id="reasonDropdown" class="swal2-input" style="flex: 1; font-size:12px">
                <option value="">-- Select Reason --</option>
                ${optionsHtml}
              </select>
            </div>
            <hr style="margin-top: 10px; margin-bottom: 0px;" />
          `,
          width: '40%',
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Yes - Close batch',
          cancelButtonText: 'No',
          // didOpen: () => {
          //   const reasonSelect = document.getElementById('reasonDropdown');
          //   const reasonError = document.getElementById('reasonError');
          //
          //   if (reasonSelect && reasonError) {
          //     reasonSelect.addEventListener('change', () => {
          //       if (reasonSelect.value !== '') {
          //         reasonError.style.display = 'none';
          //       }
          //     });
          //   } else {
          //     console.error('Dropdown or error element not found in DOM.');
          //   }
          // },
          buttonsStyling: false, // This is critical
          customClass: {
            confirmButton: 'swal2-outline-button',
            cancelButton: 'swal2-filled-button',
            actions: 'swal2-actions-split',
            htmlContainer: 'scantally-container-class'
          },
          preConfirm: () => {
            const reason = document.getElementById('reasonDropdown').value;
            if (!reason) {
              swal.showValidationMessage('Please select a reason before proceeding.');
              return false;
            }
            return reason;
          }
        });

        if (isConfirmed) {

          console.log('Batch close confirmed. Reason:', value);
          batchClosePayload.Status = 'partialclose',
          batchClosePayload.Reason = value

          // Your API or method here
          this.stbatchclosure(batchClosePayload);
        }


        // let message = {
        //   title: 'Important Alert!',
        //   body: `<p style="color:red"><b>Scantally for all pending shipments is not completed for this batch!</b></p>  <p style="color:green"> Do you want to close this batch? <br/></p>`,
        // };
        // let res = await this.$dialog.confirm(message, {
        //   html: true,
        //   animation: 'bounce',
        //   backdropClose: true,
        //   okText: 'Yes - Close batch',
        //   cancelText: 'No',
        //   reverse: true
        //   //loader: true
        // })
        // this.partialCloseModal = true
        // if( res ) {
        //   //call close api function.
        //   batchClosePayload.Status = 'partialclose';
        //   console.log('Dialog box for partial closure ..............----->>', res);
        //   this.stbatchclosure(batchClosePayload);
        // }

      } else {
        //final closed
        this.stbatchclosure(batchClosePayload);

      }
    },
    stbatchclosure(reqobj) {
      console.log('Request close object ------->>', reqobj);
      try {
        this.Loading = true;

        axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/closeBatch', reqobj)
          .then((response) => {
            if (response.data.code === 200) {
              let TrackerInfo = {
                projectname: "Last Mile",
                type: "Web",
                userid: this.localuserid,
                username: this.localusermailid,
                meta: {
                  "event": "closeBatch",
                  "BatchID": reqobj.BatchID,
                  "CurrentHubID": this.hubname,
                  "Status": reqobj.Status
                }
              }
              this.PageTracker(TrackerInfo);
              let closeType = reqobj.Status == 'partialclose' ? 'Partial Closed' : 'Closed';
              this.$alertify.success(`Batch Closed Successfully`);
              //console.log('this.getSummaryObj',this.getSummaryObj);
              this.getBatchDetails();
            } else {
              this.$alertify.error(response.data.message);
            }
            this.Loading = false;
            this.scanShipmentBatchFlag = false;
          })
          .catch((httpException) => {
            this.scanShipmentBatchFlag = false;
            this.$alertify.error("Unable to close batch");
            console.error('exception is:::::::::', httpException)
          })
      } catch(e) {
        console.log('Uncaought error --', e);
      }

    },
    showBatch() {
      this.getBatchDetails();
    },
    async TallyBatch(BatchID) {
      let result = await this.updateTallyFunctions(BatchID)
      console.log('result', result);
    },
    updateTallyFunctions(BatchID) {
      return new Promise((resolve, reject) => {
        this.Loading = true;
        let TallyBatchPayload = {
          "HubID": this.hubname,
          "BatchID": BatchID,
          "CreatedBy": this.localusermailid
        }
        axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/tallyBatch', TallyBatchPayload)
          .then((response) => {
            if (response.data.code === 200) {
              this.$alertify.success('Shipment Scan Tally successful..');
              this.getBatchDetails();
            } else if (response.data.code === 202) {
              this.$alertify.error('Invalid !! Batch details not available');
            } else {
              this.$alertify.error(response.data.message);
            }
            this.Loading = false;
            resolve(true)
          })
          .catch((httpException) => {
            this.scanShipmentBatchFlag = false;
            this.$alertify.error("Unable to Tally batch");
            resolve(false)
            console.error('exception is:::::::::', httpException)
          })
      })
    },
    updateBatch(batchId) {
      this.Loading = true;
      let updateBatchPayload = {
        "HubID": this.hubname,
        "BatchID": batchId,
        "LastModifiedBy": this.localusermailid
      }
      //console.log('updateBatchPayload',updateBatchPayload);
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/updateBatch', updateBatchPayload)
        .then((response) => {
          if (response.data.code === 200) {
            this.$alertify.success('updated batch tally successful..');
            this.getBatchDetails();
          } else if (response.data.code === 202) {
            this.$alertify.error(response.data.message);
          } else {
            this.$alertify.error(response.data.message);
          }
          this.Loading = false;
        })
        .catch((httpException) => {
          this.$alertify.error("Unable to Tally update batch");
          console.error('exception is:::::::::', httpException)
        })
    },
    ReloadBatchData() {
      this.getBatchDetails();
      this.ResetForm()
    },
    scanShipments(batchId, batchStatus) {
      const scanShipmentDiv = document.getElementById('scanShipmentDiv');
      if (scanShipmentDiv) {
          scanShipmentDiv.scrollIntoView({ behavior: 'smooth' }); // Scroll to the div smoothly
      }
      this.batchStatus = batchStatus;
      this.BatchNo = batchId;
      this.scanShipmentBatchFlag = true;
      this.getShipmentScanObj = [];
      this.scanFlag = false;
      $("#shippingId").focus();
      if (batchStatus.toLowerCase().trim() == 'partialclose') {
        this.IsImageUploadRequired = true;
      } else {
        this.IsImageUploadRequired = false;
      }
      this.clearScanForm();
      if (this.changeStatus == 1) {
        this.getInscanImageList();
      }
    },
    exportShipmentData(batchId, downLoadType, isDownload, batch) {
      // this.shipmentScanTallyList(batchId, downLoadType, isDownload);
      this.downloadShipmentDetailsLoading = true;
      let searchTypePayload = {
        "BatchId": batchId,
        "SearchType": downLoadType,
        "HubId": this.hubname,
        "ShipmentType": '',
        "ShipmentSubType": ''
      }
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/new/getShipments', searchTypePayload)
        .then((response) => {
          if (response.data.code === 200) {
            this.getShipmentList = response.data.data;
            const hubName=this.getShipmentList[0].CurrentHubName;
            const createdBy=batch.CreatedBy;
            const createdDate=batch.CreatedDate;
            const closedBy=batch.LastModifiedBy;
            const closedDate=batch.ClosedDate;
            const commonData = [
              [ 'Batch Created By:', createdBy ,'','Batch opened timestamp',createdDate,],
              [ 'Batch Closed By:', closedBy ,'','Batch closed timestamp',closedDate,],
              ['Hub Name',  hubName],
              [ 'Batch ID', batchId,],
              ['Shipping ID','ScanTally InScan Date','Status','Shipment Status','Notification Type','OctroiMRP',
                'NetPayment','Shipping Date','LastProcessDate','OrderType','GapDays','Comments'
              ],
              [],
            ];
            let getshipmentObjDetails = [];
            // this.getShipmentList.forEach(function (item) {
            //   getshipmentObjDetails.push({
            //     // "Batch ID": item.BatchID,
            //     "Shipping ID": item.ShippingID,
            //     "ScanTally InScan Date": item.IsInscan == 1 ? item.LastModifiedDate : '',
            //     "Status": item.Status,
            //     "Shipment Status": item.ShipmentStatus,
            //     // "Current Hub Name": item.CurrentHubName,
            //     "Notification Type": item.NotificationType,
            //     "OctroiMRP": item.OctroiMRP,
            //     "NetPayment": item.NetPayment,
            //     "Shipping Date": item.ShippingDate,
            //     "LastProcessDate": item.LastProcessDate,
            //     "OrderType": item.OrderType,
            //     "GapDays": item.GapDays,
            //     "Comments": item.Comments
            //   }
            //   )
            // });

            this.getShipmentList.forEach(function (item) {
              getshipmentObjDetails.push([item.ShippingID,
                 item.IsInscan == 1 ? item.LastModifiedDate : '',
                 item.Status,
                 item.ShipmentStatus,
                 item.NotificationType,
                 item.OctroiMRP,
                 item.NetPayment,
                 item.ShippingDate,
                 item.LastProcessDate,
                 item.OrderType,
                 item.GapDays,
                 item.Comments
              ]
              )
            });

            console.log(getshipmentObjDetails,'-----------------------------')
            this.exportCsv1(getshipmentObjDetails, commonData);
            // this.shipmentDetailsModel = false;
          } else if (response.data.code === 202) {
            this.$alertify.error(response.data.message);
            this.getShipmentList = [];
          } else {
            this.$alertify.error("Error while getting shipment Details");
            this.getShipmentList = [];
          }
          this.downloadShipmentDetailsLoading = false;
        })
        .catch((httpException) => {
          this.downloadShipmentDetailsLoading = false;
          this.scanShipmentBatchFlag = false;
          this.$alertify.error("Unable to get summary details");
          console.error('exception is:::::::::', httpException)
        })
    },
    closeshipmentDetailsModel() {

      this.shipmentDetailsModel = false;
    },
    shipmentScanTallyList(batchId, typeName, shipmentType, subShipemntType, downLoadType = false) {
      // if(downLoadType == 'ExportTotalShipment'){
      //   this.shipmentDetailsFlag = false;
      // } else{
      //   this.shipmentDetailsFlag = true;
      // }
      this.getModelBatchNo = ''
      this.shipmentDetailsModel = false
      this.ShipmentDetailsLoading = true;
      this.shipmentStatusType = typeName;
      //this.BatchNo = batchId;
      this.shipmentDetailsModel = true;
      let searchTypePayload = {
        "BatchId": batchId,
        "SearchType": typeName,
        "HubId": this.hubname,
        "ShipmentType": shipmentType,
        "ShipmentSubType": subShipemntType
      }
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/new/getShipments', searchTypePayload)
        .then((response) => {
          if (response.data.code === 200) {
            this.getShipmentList = response.data.data;
            let getshipmentObjDetails = [];
            this.getShipmentList.forEach(function (item) {
              getshipmentObjDetails.push({
                "Batch ID": item.BatchID,
                "Shipping ID": item.ShippingID,
                "ScanTally InScan Date":  item.scantallyinscandate,
                "Status": item.Status,
                "Shipment Status": item.ShipmentStatus,
                "Current Hub Name": item.CurrentHubName,
                "Notification Type": item.NotificationType,
                "OctroiMRP": item.OctroiMRP,
                "NetPayment": item.NetPayment,
                "Shipping Date": item.ShippingDate,
                "LastProcessDate": item.LastProcessDate,
                "OrderType": item.OrderType,
                "GapDays": item.GapDays,
                "Comments": item.Comments
              }
              )
            });

            if (downLoadType) {
              this.exportCsv(getshipmentObjDetails);
              // this.shipmentDetailsModel = false;
            } else {
              this.getModelBatchNo = batchId
            }
          } else if (response.data.code === 202) {
            this.$alertify.error(response.data.message);
            this.getShipmentList = [];
          } else {
            this.$alertify.error("Error while getting shipment Details");
            this.getShipmentList = [];
          }
          this.ShipmentDetailsLoading = false;
        })
        .catch((httpException) => {
          this.ShipmentDetailsLoading = false;
          this.scanShipmentBatchFlag = false;
          this.$alertify.error("Unable to get summary details");
          console.error('exception is:::::::::', httpException)
        })

    },
    exportCsv(shipmentObjectdata) {
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "ShipmentDetails" + today + ".csv";
      csvContent += [
        Object.keys(shipmentObjectdata[0]).join(";"),
        ...shipmentObjectdata.map(item => Object.values(item).join(";"))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    onuploadChange(event) {
      const file = event.target.files[0];
      this.file = file;

      let FilterExtention = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png"];
      if (!FilterExtention.includes(this.file.type)) {
        this.invalidFile.value = true;
        this.validated = false;
        this.invalidFile.errorMessage = 'Please upload only images.!';
        this.$alertify.error("Please upload only images");
      } else if (this.file.size >= 1024 * 1024 * 10) {
        this.validated = true;
        this.invalidFile.value = true;
        this.invalidFile.errorMessage = 'Please check image size should be less than 10MB .!';
        this.$alertify.error("Please check image size should be less than 10MB ");
        const input = this.$refs.uploadfile;
        input.type = 'text';
        input.type = 'file';
        this.validated = false;
      } else {
        this.invalidFile = {};
        this.validated = true;
      }

      if (this.file != '' && this.file != undefined) {
        this.isCloseButtonUpload = true;
      } else {
        this.isCloseButtonUpload = false;
      }
      // console.log('this.file', this.file);
      // this.validated = true;
    },
    uploadFile() {
      if (!this.file) {
        this.$alertify.error('Please selecct file');
      } else if (this.shippingId != '') {
        const formData = new FormData();
        formData.append('shippingId', this.shippingId);
        formData.append('BatchID', this.BatchNo);
        formData.append('file', this.file);
        let FilterExtention = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png"];
        if (!FilterExtention.includes(this.file.type)) {
          this.$alertify.error("Please upload only images");
        } else if (this.file.size >= 1024 * 1024 * 10) {
          this.validated = true;
          this.$alertify.error("Please check image size should be less than 10MB ");
          const input = this.$refs.uploadfile;
          input.type = 'text';
          input.type = 'file';
          this.validated = true;
        } else {
          this.validated = true;
          this.uploadLoading = true;
          axios.post(apiUrl.api_url_for_scantally + 'ScanTally/ShipmentScanTallyUpload', formData)
            .then((response) => {
              if (response.data.code === 200) {
                this.getInscanImageList()
                this.$alertify.success('uploaded Successfully');
              } else if (response.data.code === 202) {
                this.$alertify.error('Upload failed');
              } else {
                this.$alertify.error(response.data.message);
              }
              this.uploadLoading = false;
            })
            .catch((httpException) => {
              this.scanShipmentBatchFlag = false;
              this.uploadLoading = false;
              this.$alertify.error("Unable to upload file");
              console.error('exception is:::::::::', httpException)
            })
        }
      } else {
        this.$alertify.error('Please Enter ShippingId before upload')
        document.getElementById('shippingId').focus();
      }
    },
    getInscanImageList() {
      let imgParamPayload = {
        "batchid": this.BatchNo,
        "hubid": this.hubname
      }
      axios.post(apiUrl.api_url_for_scantally + 'ScanTally/shipmentInscanAttachmentDownload', imgParamPayload)
        .then((response) => {
          //console.log('response',response);
          if (response.data.code === 200) {
            this.imageListObject = response.data.data;
          } else {
            this.imageListObject = [];
            //this.$alertify.error(response.data.message);
          }
        })
        .catch((httpException) => {
          this.$alertify.error("No Records Found");
          console.error('exception is:::::::::', httpException)
        })
    },
    downloadFile(filePath) {
      var link = document.createElement('a');
      link.href = filePath;
      link.setAttribute('target', '_blank');
      window.open(filePath, '_blank');
      return true;
    },
    collapseUpslide() {
      var x = document.getElementById("hiddentable");
      if (x.style.display === "none") {
        this.toggleFlag = true
        x.style.display = "block";
      } else {
        this.toggleFlag = false
        x.style.display = "none";
      }

    },
    clearAll() {
      this.errormsg = [];
      this.scanShipmentBatchFlag = false;
      this.shipmentDetailsFlag = false
      this.showBatchesFlag = false;
      this.getSummaryObj = [];
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.$validator.reset();
      this.errors.clear();
      this.clearScanForm();

    },
    clearScanForm() {
      console.log('console clear clicks');
      this.checkValue = 0
      this.shippingId = '';
      this.comments = '';
      this.Ismannual = false;
      this.keyFiredCount.value = 0
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.isCloseButtonUpload = false
      this.invalidFile = {};
      this.$validator.reset();
      this.errors.clear();
      $("#shippingId").focus();
    },
    buttonReset() {
      this.clearScanForm();
      this.scanFlag = false;
      this.getShipmentScanObj = {};
      this.scanBadgeFlag = false;
      this.badge = {
        colorCode: "",
        icon: "",
        shipment: ""
      }
    },
    ResetForm() {
      this.keyFiredCount.value = 0
      this.getShipmentScanObj = [];
      this.scanFlag = false;
      this.scanBadgeFlag = false;
      this.badge = {
        colorCode: "",
        icon: "",
        shipment: ""
      }
      this.$validator.reset();
      this.errors.clear();
    },
    resetFile() {
      const input = this.$refs.uploadfile;
      this.file = '';
      input.type = 'text';
      input.type = 'file';
      this.validated = true
      this.isCloseButtonUpload = false
      this.invalidFile = {};
      this.$alertify.success('File Removed Successfully');
    },
    removeFile() {

      if (this.file) {
        if (this.shippingId != '') {
          let getextension = this.file.name.split(".");
          if (getextension.length != 0) {
            let filePath = 'ScanTally/' + this.BatchNo + '/' + this.shippingId + '.' + getextension[1];
            let imgParamPayload = {
              "PathKey": filePath
            }
            this.uploadLoading = true;
            axios.post(apiUrl.api_url_for_scantally + 'ScanTally/shipmentInscanAttachmentRemove', imgParamPayload)
              .then((response) => {
                //console.log('Remove Image response',response);
                if (response.data.code === 200) {
                  this.$alertify.success('File Removed Successfully');
                  this.file = '';
                  let imageRemoveObject = response.data.data;
                } else {
                  this.$alertify.error('file not deleted');
                }
                this.uploadLoading = false;
              })
              .catch((httpException) => {
                this.uploadLoading = false;
                this.$alertify.error("No Records Found");
                console.error('exception is:::::::::', httpException)
              })
          }

          const input = this.$refs.uploadfile;
          input.type = 'text';
          input.type = 'file';
          this.validated = true
          this.isCloseButtonUpload = false

        } else {
          this.$alertify.error('Please enter ShippingId')
        }
      }
    },
    changeDateFormat() {
      let current_datetime = new Date()
      let formatted_date = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + (current_datetime.getDate())).slice(-2);
      this.dateobj.toDate = formatted_date;
    },
    clear() {
      this.changeDateFormat();
      this.checkValue = 1
      //this.changeStatus = 1
      this.keyFiredCount.value = 0
      this.errormsg = [];
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.isCloseButtonUpload = false
      this.invalidFile = {};
      this.scanShipmentBatchFlag = false;
      this.shipmentDetailsFlag = false
      this.showBatchesFlag = false;
      this.exclude = "";
      this.Include = "";
      this.$validator.reset();
      this.errors.clear();
      this.getSummaryObj = '';
    },
    showUploadFileComments() {
      if (this.Ismannual == true) {
        this.checkValue = 1
      } else {
        this.checkValue = 0
      }
      this.changeStatus = 1
    },

    syncBatchData() {
      this.dismissCountDownSuccessforSync = 0;
      this.Loading = true
      let searchTypePayload = {
        "BatchId": this.scanTallyBatchId,
        "HubId": this.hubname,
        "Pagelimit": this.syncDataLimit,
        "roleName": this.rolename.toLowerCase().trim()
      }
      axios.post(apiUrl.api_url_for_scantally + 'syncScanTallyData', searchTypePayload)
        .then((response) => {
          if (response.data.code === 200) {
            this.dismissCountDownSuccessforSync = this.dismissSecs
            this.$alertify.success('Please wait, data sync is in progress....');
          } else {
            this.$alertify.error('Data not synced');
          }
          this.Loading = false
        })
        .catch((httpException) => {
          this.$alertify.error("Data not synced");
          console.error('exception is:::::::::', httpException)
        })
    },

    getSyncDataLimit() {
      this.syncDataLimit = 0;
      let syncDataKey = {
        "key": "scanTallySyncDataLimit"
      }
      axios.post(apiUrl.api_url_for_scantally + 'memcache/get', syncDataKey)
        .then((response) => {
          if (response.data.code == 200) {
            let syncData = JSON.parse(response.data.message)
            this.syncDataLimit = syncData.dataLimit
          }
          if (response.data.message == false) {
            this.$alertify.error("Sync data limit not found");
          }
        })
    },

    rowCount(data, mainType) {
      // Calculate the rowspan for the mainType column
      return (this.dataExists(data, mainType, 'Regular') ? 1 : 0) + (this.dataExists(data, mainType, 'Heavies') ? 1 : 0);
    },
    dataExists(data, mainType, groupType) {
      // Check if data exists for a specific mainType and groupType
      return data.some(item => item.shipmenttype === mainType && item.GroupType === groupType);
    },
    getData(summaryObject, mainType, groupType, field) {
      // Get the data for a specific mainType, groupType, and field
      const item = summaryObject.find(item => item.shipmenttype === mainType && item.GroupType === groupType);
      return item ? item[field] : '0';
    },
    getTotal(summaryObject, columnName) {
      // Filter out objects with shipmenttype as null and then calculate the total count for the specified column
      return summaryObject.reduce((total, item) => {
        if (item.shipmenttype) {
          return total + parseInt(item[columnName] || 0);
        } else {
          return total;
        }
      }, 0);
    },
    filterOpenStatus(data) {
      return data.flatMap(array => array.filter(obj => obj.Status.toLowerCase() === 'processdone'));
    },
    validateForm2(scope) {

    },
    getScanTallyObject(hubScantally, auditScantally, tablink) {
      let syncDataKey = {
        "CurrentHubID": this.hubname
      }
      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/new/configsettings', syncDataKey)
        .then((response) => {
          if (response.data.code == 200) {
            let featureData = response.data.data
            this.ofdclosureflag = featureData.isBatchOFDPendingClosure
            this.partialCloseFlag = featureData.partialclosureflag
            this.isDownloadflag = featureData.isDataDownload
            this.isManualShipmentScanAllowed = featureData.isManualShipmentScanAllowed || false;
            if (featureData.featureFlag == false){
              this.$router.push('/ShipmentScanTallyNew');
            } else if(featureData.featureFlag == true && hubScantally == false) {
              // console.log('ONLY AUDIT ST');
              this.$router.push('/ShipmentScanTallyNew');
            } else {
              // console.log('LANDING HERE FOR EXECUTIVE');
              this.changeStatus = '1'
            }
          }
        })
    },
    formatDate(date) {
      // Format the date to 'yyyy-mm-dd'
      date.setHours(date.getHours() + 5); // Adding 5 hours
      date.setMinutes(date.getMinutes() + 30); // Adding 30 minutes
      return date.toISOString().split('T')[0];
    },
    partialClosureModal(){
      this.partialCloseModal = false
    },
    exportCsv1(shipmentObjectdata, commonData=null) {
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "ShipmentDetails" + today + ".csv";
      commonData ? csvContent +=
        commonData.map(row => row.join(',')).join('\n') :null;


        csvContent +=
        shipmentObjectdata.map(row => row.join(',')).join('\n');
      // csvContent += [
      //   Object.keys(shipmentObjectdata[0]).join(";"),
      //   ...shipmentObjectdata.map(item => Object.values(item).join(";"))
      // ]
      //   .join("\n")
      //   .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/NewShipmentScantally/NewShipmentScantally.component.js